module.exports = __webpack_public_path__ + "static/klimaatverandering-wateroverlast-zeespiegelstijging-4d81d3e7f6b0af34a2c1825835901be4.jpg";